import React from "react";

function ChatIconOne({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.53027 0.3125C12.6611 0.3125 16.0303 3.06641 16.0303 6.40625C16.0303 9.77539 12.6611 12.5 8.53027 12.5C7.56348 12.5 6.65527 12.3535 5.80566 12.0898C4.95605 12.7051 3.52051 13.4375 1.7334 13.4375C1.44043 13.4375 1.17676 13.291 1.05957 13.0273C0.97168 12.7637 1.00098 12.4707 1.20605 12.2656C1.23535 12.2656 2.14355 11.2695 2.55371 10.127C1.58691 9.10156 1.03027 7.8125 1.03027 6.40625C1.03027 3.06641 4.37012 0.3125 8.53027 0.3125ZM8.53027 11.0938C11.8701 11.0938 14.624 9.01367 14.624 6.40625C14.624 3.82812 11.8701 1.71875 8.53027 1.71875C5.16113 1.71875 2.43652 3.82812 2.43652 6.40625C2.43652 7.66602 3.05176 8.60352 3.5791 9.16016L4.19434 9.80469L3.87207 10.625C3.72559 11.0352 3.52051 11.4453 3.28613 11.7969C3.98926 11.5625 4.5752 11.2402 4.98535 10.9473L5.54199 10.5371L6.21582 10.7422C6.94824 10.9766 7.73926 11.0938 8.53027 11.0938Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ChatIconOne;
